import React, { useState } from "react";
import './NumberStepper.css';

interface StepperProps {
    value: number;
    min?: number;
    max?: number;
    step?: number;
    onChange: (value: number) => void;
}

const Stepper: React.FC<StepperProps> = ({
    value,
    min = 0,
    max = 100,
    step = 1,
    onChange,
}) => {
    const [input, setInput] = useState<string>(value.toString());
    const [error, setError] = useState<string>('');

    const handleChangeInput = (parsedValue: number) => {
        if (!isNaN(parsedValue)) {
            setInput(parsedValue.toString()); 
            if(parsedValue === 0) {
                setInput(min.toString()); 
                onChange(parsedValue);
            }
        }
        if (parsedValue < min) {
            setError(`min. ${min}`);
            var minVal = min.toString();
            setInput(minVal);
            onChange(Number(minVal));
        } else if (parsedValue > max) {
            setError(`max. ${max}`);
            var maxVal = max.toString();
            setInput(maxVal);
            onChange(Number(maxVal));
        } else {
            setError("");
            onChange(parsedValue);
        }
    }

    const handleDecrease = () => {
        var inputValue = Number(input);
        handleChangeInput(inputValue - step);
    }
    const handleIncrease = () => {
        var inputValue = Number(input);
         handleChangeInput(inputValue + step) }
    return (
        
        <div className="row">
            <div style={{width: '22%'}}>

                <span className="icon" onClick={handleDecrease}>
                   <i className='bi bi-dash-lg fs-5 ds-text-primary'></i>
                </span>

            </div>
            <div style={{width: '52%', marginTop:'-10px'}}>
              <div className="d-flex justify-content-center">
                <input 
                      type="text" 
                      className="rounded-input" 
                      value={input} 
                      style={{borderColor: error ? 'red' : 'var(--primary-color)'}}
                      onChange={(e) => {
                        const inputVal = e.target.value;
                        if(inputVal === '') {
                            setInput('');
                            onChange(0);
                            setError('min 1');
                            return;
                        }
                        const parsedValue = Number(inputVal);
                        handleChangeInput(parsedValue);
                    }}    
              />
              
              </div>
              {error &&
                <div style={{color:'red', marginLeft:'6px'}}>
                    <span>{error}</span>
                </div>
             }
            </div>
            <div  style={{width: '1%', paddingLeft:'0px'}}>
                 <span className="icon" onClick={handleIncrease}>
                   <i className='bi bi-plus-lg fs-5 ds-text-primary'></i>
                </span>
            </div>
        </div>
    );
};

export default Stepper;
